import { Button } from "@mui/material";
import React, { useState } from "react";
import FeedbackModal from "./FeedbackModal";
import ChatIcon from '@mui/icons-material/Chat';
import { useIsAuthenticated } from "@azure/msal-react";
import useLiteratureCurrentView from "../hooks/useLiteratureCurrentView";
import { usePhoneMode } from "../../../hooks";

export default function FeedbackButton() {
    const [showFeedback, setShowFeedback] = useState(false);
    const isAuthenticated = useIsAuthenticated();
    const { isInFaultList, isInFaultView, isInDocumentListView, isInEngineInfo } = useLiteratureCurrentView();
    const { phoneMode } = usePhoneMode();

    if ((!isAuthenticated || isInFaultView || isInFaultList || phoneMode) &&
        !isInDocumentListView && !isInEngineInfo) {
        return null;
    }

    return (
        <>
            <Button
                color="inherit"
                title='Send Feedback'
                onClick={() => setShowFeedback(!showFeedback)}
            >
                <ChatIcon />
            </Button>
            <FeedbackModal
                open={showFeedback}
                onClose={() => setShowFeedback(false)}
            />
        </>
    );
}